import React from 'react';
import { useTheme } from '@material-ui/core';
import BaseTypography from '../../Text/BaseTypography';
import { SignatureStatusTypes } from '../../../store/files/types';
import { BaseStatusIndicator } from './BaseStatusIndicator';
import * as Colors from '../../../theme/colors';

interface ESignatureStatusIndicatorProps {
  signatureStatus: SignatureStatusTypes;
}
export const ESignatureStatusIndicator: React.FC<ESignatureStatusIndicatorProps> = ({
  signatureStatus,
}) => {
  const theme = useTheme();

  const isSignatuStatusCompleted =
    signatureStatus === 'done' || signatureStatus === 'signed';

  return (
    <BaseStatusIndicator
      title={
        <>
          <BaseTypography
            fontType="13Medium"
            style={{ color: Colors.BlackHeadings }}
          >
            eSignature Status
          </BaseTypography>
          <BaseTypography
            fontType="12Regular"
            style={{ color: Colors.BlackSmall }}
          >
            {isSignatuStatusCompleted ? 'Completed' : 'In progress'}
          </BaseTypography>
        </>
      }
      isSuccess={isSignatuStatusCompleted}
      hasTooltip
    />
  );
};
